import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import { FileContent, FileNode } from '@nebula/shared-vault/domain';

@Injectable({
  providedIn: 'root',
})
export class MockFileService {
  private mockFileTree: FileNode[] = [
    {
      name: 'Technical Group',
      path: '/technical-group',
      type: 'directory',
      expanded: false,
      children: [
        {
          name: 'cs team',
          path: '/technical-group/cs-team',
          type: 'directory',
          expanded: false,
          children: [
            {
              name: 'Tom',
              path: '/technical-group/cs-team/Tom',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'documentos.pdf',
                  path: '/technical-group/cs-team/Tom/documentos.pdf',
                  type: 'file',
                  size: 1024000,
                  extension: 'pdf',
                },
                {
                  name: 'foto.jpg',
                  path: '/technical-group/cs-team/Tom/foto.jpg',
                  type: 'file',
                  size: 2048000,
                  extension: 'jpg',
                },
                {
                  name: 'imagen.svg',
                  path: '/technical-group/cs-team/Tom/imagen.svg',
                  type: 'file',
                  size: 5120,
                  extension: 'svg',
                },
              ],
            },
            {
              name: 'june',
              path: '/technical-group/cs-team/june',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'informe.docx',
                  path: '/technical-group/cs-team/june/informe.docx',
                  type: 'file',
                  size: 512000,
                  extension: 'docx',
                },
              ],
            },
            {
              name: 'sam',
              path: '/technical-group/cs-team/sam',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'datos.xlsx',
                  path: '/technical-group/cs-team/sam/datos.xlsx',
                  type: 'file',
                  size: 102400,
                  extension: 'xlsx',
                },
              ],
            },
          ],
        },
        {
          name: 'technical team',
          path: '/technical-group/technical-team',
          type: 'directory',
          expanded: false,
          children: [
            {
              name: 'betty',
              path: '/technical-group/technical-team/betty',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'manual.pdf',
                  path: '/technical-group/technical-team/betty/manual.pdf',
                  type: 'file',
                  size: 3072000,
                  extension: 'pdf',
                },
              ],
            },
            {
              name: 'anna',
              path: '/technical-group/technical-team/anna',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'config.json',
                  path: '/technical-group/technical-team/anna/config.json',
                  type: 'file',
                  size: 2048,
                  extension: 'json',
                },
                {
                  name: 'script.js',
                  path: '/technical-group/technical-team/anna/script.js',
                  type: 'file',
                  size: 8192,
                  extension: 'js',
                },
                {
                  name: 'video.mp4',
                  path: '/technical-group/technical-team/anna/video.mp4',
                  type: 'file',
                  size: 10485760,
                  extension: 'mp4',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'consulting',
      path: '/consulting',
      type: 'directory',
      expanded: false,
      children: [
        {
          name: 'consulting 1',
          path: '/consulting/consulting-1',
          type: 'directory',
          expanded: false,
          children: [
            {
              name: 'leo',
              path: '/consulting/consulting-1/leo',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'presentacion.pdf',
                  path: '/consulting/consulting-1/leo/presentacion.pdf',
                  type: 'file',
                  size: 5120000,
                  extension: 'pdf',
                },
              ],
            },
            {
              name: 'odry',
              path: '/consulting/consulting-1/odry',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'reporte.xlsx',
                  path: '/consulting/consulting-1/odry/reporte.xlsx',
                  type: 'file',
                  size: 256000,
                  extension: 'xlsx',
                },
              ],
            },
          ],
        },
        {
          name: 'consulting 2',
          path: '/consulting/consulting-2',
          type: 'directory',
          expanded: false,
          children: [
            {
              name: 'kim',
              path: '/consulting/consulting-2/kim',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'analisis.xlsx',
                  path: '/consulting/consulting-2/kim/analisis.xlsx',
                  type: 'file',
                  size: 512000,
                  extension: 'xlsx',
                },
              ],
            },
            {
              name: 'judy',
              path: '/consulting/consulting-2/judy',
              type: 'directory',
              expanded: false,
              children: [
                {
                  name: 'propuesta.pdf',
                  path: '/consulting/consulting-2/judy/propuesta.pdf',
                  type: 'file',
                  size: 2048000,
                  extension: 'pdf',
                },
                {
                  name: 'notas.txt',
                  path: '/consulting/consulting-2/judy/notas.txt',
                  type: 'file',
                  size: 1024,
                  extension: 'txt',
                },
                {
                  name: 'cancion.mp3',
                  path: '/consulting/consulting-2/judy/cancion.mp3',
                  type: 'file',
                  size: 3145728,
                  extension: 'mp3',
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  getFileTree(): Observable<FileNode[]> {
    return of(this.mockFileTree).pipe(delay(300));
  }

  getFileContent(file: FileNode): Observable<FileContent> {
    let content = '';
    let type = 'text/plain';

    if (file.extension === 'pdf') {
      content = '%PDF-1.4\nmock\n2 0 obj\n<< /Type /Catalog /Pages 3 0 R >>\nendobj\n...';
      type = 'application/pdf';
    } else if (file.extension === 'jpg' || file.extension === 'jpeg' || file.extension === 'png') {
      content = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD...';
      type = `image/${file.extension}`;
    } else if (file.extension === 'svg') {
      content = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="#4285f4" />
        <text x="50" y="55" text-anchor="middle" fill="white" font-size="20">SVG</text>
      </svg>`;
      type = 'image/svg+xml';
    } else if (file.extension === 'mp4') {
      content = 'data:video/mp4;base64,AAAAIGZ0eXBpc29t...';
      type = 'video/mp4';
    } else if (file.extension === 'mp3') {
      content = 'data:audio/mpeg;base64,SUQzBAAAAAAB...';
      type = 'audio/mpeg';
    } else if (file.extension === 'docx') {
      content = 'PK\\u0003\\u0004...';
      type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else if (file.extension === 'xlsx') {
      content = 'PK\\u0003\\u0004...';
      type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (file.extension === 'json') {
      content = JSON.stringify(
        {
          nombre: file.name,
          descripcion: 'Archivo de configuracion',
          version: '1.0.0',
        },
        null,
        2,
      );
      type = 'application/json';
    } else if (file.extension === 'js') {
      content = '// JavaScript file\n\nfunction main() {\n  return true;\n}';
      type = 'text/javascript';
    } else if (file.extension === 'txt') {
      content = 'Este es un archivo de texto de ejemplo.\nContiene multiples lineas.\nPuede ser editado facilmente.';
      type = 'text/plain';
    } else {
      content = `Contenido de ${file.name}`;
    }

    return of({
      name: file.name,
      path: file.path,
      content: content,
      type: type,
      size: file.size,
      modified: new Date(),
    }).pipe(delay(100));
  }
}
